import Container from '@v2/shared/components/Container';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';

/*
 * The "We serve:" band at the foot of every bulk-order page, each phrase linking to the
 * variant that covers it. Several phrases point at the same page on purpose — the words
 * are the ones people search for, the destinations are the five pages that exist. The
 * slug is appended to `/bulk-order/` here so it stays right for whichever site is serving.
 */
const items: { label: string; slug: string }[] = [
  { label: 'Doctors', slug: 'medical-offices' },
  { label: 'Hospitals', slug: 'medical-offices' },
  { label: 'Medical Offices', slug: 'medical-offices' },
  { label: 'Dentists', slug: 'dental-offices' },
  { label: 'Businesses', slug: 'corporate-offices' },
  { label: 'Offices', slug: 'corporate-offices' },
  { label: 'Schools', slug: 'school-libraries' },
  { label: 'Libraries', slug: 'school-libraries' },
  { label: 'Waiting Rooms', slug: 'waiting-rooms' },
];

export default function WeServe() {
  const { buildUrl } = useUrlGenerator();

  return (
    <section className="py-10 bg-slate-100">
      <Container>
        <p className="text-center w-full text-lg">
          <strong className="font-semibold">We serve:</strong>{' '}
          {items.map((item, index) => (
            <span key={`${item.label}-${index}`}>
              <a
                href={buildUrl(`/bulk-order/${item.slug}`)}
                className="text-red-600 font-semibold no-underline"
              >
                {item.label}
              </a>
              {' • '}
            </span>
          ))}
          And More
        </p>
      </Container>
    </section>
  );
}
